import React from "react";
import allImageOfClient from "../../assets/fake-data/clientImages";

const ClientImage = () => {
  return (
    <>
      <section className="py-20">
        <div className="container bg-light rounded">
          <div className="grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 space-y-4 md:space-y-0 items-center">
            {allImageOfClient.slice(0, 4).map((x, index) => {
              return (
                <div key={index} className="md:py-9 py-5">
                  <img src={x.image} alt="logo-img" className="mx-auto block" />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ClientImage;
